// 甜蜜惩罚漫画网 - 内容模拟数据

export const siteMeta = {
  name: "甜蜜惩罚漫画网",
  shortName: "甜蜜惩罚",
  tagline: "单行本全卷 · 连载话 · 全彩版本 · 番外收录，找齐整部作品更方便",
  desc: "甜蜜惩罚漫画网专注《甜蜜惩罚》漫画单行本与连载话阅读，按卷与话数整理目录，全彩版本与番外一并收录。",
  keywords: "甜蜜惩罚漫画,甜蜜惩罚漫画单行本,甜蜜惩罚漫画卷,甜蜜惩罚漫画话,甜蜜惩罚漫画全彩,甜蜜惩罚漫画连载,甜蜜惩罚漫画番外",
};

export interface Volume {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  count: string;
  tag: string;
  desc: string;
}

export const volumes: Volume[] = [
  {
    id: "v1",
    title: "第1卷",
    subtitle: "命运的契约",
    cover: "https://readdy.ai/api/search-image?query=Romance%20shoujo%20manga%20cover%20illustration%2C%20young%20woman%20with%20long%20auburn%20hair%20in%20an%20elegant%20deep%20red%20dress%2C%20gentle%20expression%2C%20soft%20rose%20and%20warm%20gold%20background%20with%20delicate%20petals%2C%20fine%20line%20art%2C%20dreamy%20romantic%20atmosphere%2C%20high%20quality%20digital%20painting%2C%20portrait%20composition&width=600&height=800&seq=vol-01&orientation=portrait",
    count: "全彩 6 话",
    tag: "单行本",
    desc: "第一卷拉开故事帷幕。平凡的女主角在一次意外中卷入上层社会的秘密，与身份悬殊的男主角定下无法反悔的契约，一场关于尊严与真心的博弈就此开始。",
  },
  {
    id: "v2",
    title: "第2卷",
    subtitle: "隐秘的心动",
    cover: "https://readdy.ai/api/search-image?query=Romance%20shoujo%20manga%20cover%20illustration%2C%20young%20woman%20with%20silky%20chestnut%20hair%20holding%20a%20white%20rose%2C%20warm%20amber%20toned%20background%20with%20bokeh%20lights%2C%20soft%20smile%2C%20delicate%20shading%2C%20romantic%20evening%20mood%2C%20elegant%20digital%20artwork%2C%20portrait%20composition&width=600&height=800&seq=vol-02&orientation=portrait",
    count: "全彩 6 话",
    tag: "单行本",
    desc: "契约生活的日常逐渐展开，两人之间的距离悄然拉近。表面冰冷的相处之下，隐藏着彼此都不愿承认的悸动，感情线在细腻的互动中缓缓推进。",
  },
  {
    id: "v3",
    title: "第3卷",
    subtitle: "试探与靠近",
    cover: "https://readdy.ai/api/search-image?query=Romance%20shoujo%20manga%20cover%20illustration%2C%20young%20couple%20silhouette%20under%20cherry%20blossom%20tree%2C%20blush%20pink%20sky%2C%20falling%20petals%2C%20tender%20mood%2C%20soft%20pastel%20colors%2C%20delicate%20line%20art%2C%20dreamy%20spring%20atmosphere%2C%20high%20quality%20illustration%2C%20portrait%20composition&width=600&height=800&seq=vol-03&orientation=portrait",
    count: "全彩 6 话",
    tag: "单行本",
    desc: "一场突如其来的风波打破了平静。试探、误会与温柔并存，主角们在一次次矛盾中重新认识彼此，感情的温度也在不经意间攀升。",
  },
  {
    id: "v4",
    title: "第4卷",
    subtitle: "破晓的告白",
    cover: "https://readdy.ai/api/search-image?query=Romance%20shoujo%20manga%20cover%20illustration%2C%20young%20woman%20with%20flowing%20hair%20gazing%20at%20dawn%20horizon%2C%20peach%20and%20gold%20sunrise%20sky%2C%20lighthouse%20in%20background%2C%20hopeful%20expression%2C%20soft%20lighting%2C%20elegant%20romantic%20art%2C%20portrait%20composition&width=600&height=800&seq=vol-04&orientation=portrait",
    count: "全彩 6 话",
    tag: "单行本",
    desc: "当伪装逐渐褪去，真心终于浮出水面。在黎明来临的那一刻，两人鼓起勇气直视内心，一段没有契约、只凭心意的告白由此开始。",
  },
  {
    id: "v5",
    title: "第5卷",
    subtitle: "交错的心事",
    cover: "https://readdy.ai/api/search-image?query=Romance%20shoujo%20manga%20cover%20illustration%2C%20young%20woman%20sitting%20by%20window%20with%20warm%20afternoon%20light%2C%20curtain%20and%20tea%20cup%2C%20pensive%20mood%2C%20rose%20and%20beige%20palette%2C%20delicate%20detail%2C%20cozy%20intimate%20atmosphere%2C%20high%20quality%20illustration%2C%20portrait%20composition&width=600&height=800&seq=vol-05&orientation=portrait",
    count: "全彩 6 话",
    tag: "单行本",
    desc: "关系更进一步，新的考验也接踵而至。来自外界的压力、内心的犹豫与身边人的目光，让这段感情在甜蜜与不安之间来回摇摆。",
  },
  {
    id: "v6",
    title: "第6卷",
    subtitle: "温柔的守护",
    cover: "https://readdy.ai/api/search-image?query=Romance%20shoujo%20manga%20cover%20illustration%2C%20young%20couple%20under%20an%20umbrella%20in%20soft%20rain%2C%20warm%20lamp%20glow%2C%20protective%20gesture%2C%20romantic%20blue%20and%20rose%20toned%20night%2C%20gentle%20shading%2C%20intimate%20mood%2C%20high%20quality%20artwork%2C%20portrait%20composition&width=600&height=800&seq=vol-06&orientation=portrait",
    count: "全彩 6 话",
    tag: "单行本",
    desc: "风雨中的相守让感情愈发坚定。无论外界如何喧嚣，他始终站在她身侧，用沉默而温柔的守护，回应她所有的恐惧与不安。",
  },
  {
    id: "v7",
    title: "第7卷",
    subtitle: "命运的转机",
    cover: "https://readdy.ai/api/search-image?query=Romance%20shoujo%20manga%20cover%20illustration%2C%20young%20woman%20in%20white%20summer%20dress%20among%20wildflowers%2C%20golden%20afternoon%20light%2C%20joyful%20expression%2C%20soft%20pastel%20rose%20sky%2C%20delicate%20line%20work%2C%20breezy%20romantic%20mood%2C%20high%20quality%20digital%20painting%2C%20portrait%20composition&width=600&height=800&seq=vol-07&orientation=portrait",
    count: "全彩 6 话",
    tag: "单行本",
    desc: "一次偶然的相遇让剧情迎来重大转折。过去被掩埋的秘密逐渐浮出水面，两人之间的羁绊也因此迎来全新的可能。",
  },
  {
    id: "v8",
    title: "第8卷",
    subtitle: "并肩同行",
    cover: "https://readdy.ai/api/search-image?query=Romance%20shoujo%20manga%20cover%20illustration%2C%20young%20couple%20walking%20together%20on%20a%20city%20street%20at%20sunset%2C%20warm%20orange%20and%20rose%20skyline%2C%20intertwined%20hands%2C%20soft%20silhouette%2C%20romantic%20atmosphere%2C%20elegant%20artwork%2C%20portrait%20composition&width=600&height=800&seq=vol-08&orientation=portrait",
    count: "全彩 6 话",
    tag: "单行本",
    desc: "风波过后，两人终于学会并肩而行。面对新的选择与责任，他们不再犹豫，而是携手迈向属于彼此的明天。",
  },
  {
    id: "v9",
    title: "第9卷",
    subtitle: "心跳的誓言",
    cover: "https://readdy.ai/api/search-image?query=Romance%20shoujo%20manga%20cover%20illustration%2C%20young%20woman%20with%20blush%20cheeks%20clutching%20a%20small%20gift%20box%2C%20rose%20garden%20background%2C%20warm%20romantic%20lighting%2C%20delicate%20details%2C%20soft%20pink%20and%20cream%20palette%2C%20high%20quality%20illustration%2C%20portrait%20composition&width=600&height=800&seq=vol-09&orientation=portrait",
    count: "全彩 6 话",
    tag: "单行本",
    desc: "感情走向稳定的同时，一颗关于未来的种子也在悄然萌发。一句轻声的誓言，让所有等待都有了温柔的回响。",
  },
  {
    id: "v10",
    title: "第10卷",
    subtitle: "跨越的距离",
    cover: "https://readdy.ai/api/search-image?query=Romance%20shoujo%20manga%20cover%20illustration%2C%20young%20couple%20on%20a%20train%20platform%2C%20farewell%20moment%2C%20soft%20blue%20dusk%20and%20warm%20station%20lights%2C%20emotional%20mood%2C%20delicate%20shading%2C%20bittersweet%20romantic%20art%2C%20portrait%20composition&width=600&height=800&seq=vol-10&orientation=portrait",
    count: "全彩 6 话",
    tag: "单行本",
    desc: "短暂的离别让感情接受考验。距离拉开的思念，反而让两颗心贴得更近，也让他们更加坚定地走向彼此。",
  },
  {
    id: "v11",
    title: "第11卷",
    subtitle: "盛夏的回声",
    cover: "https://readdy.ai/api/search-image?query=Romance%20shoujo%20manga%20cover%20illustration%2C%20young%20woman%20by%20the%20seaside%20at%20sunset%2C%20wind%20in%20her%20hair%2C%20glowing%20orange%20and%20rose%20horizon%2C%20seagulls%2C%20peaceful%20expression%2C%20warm%20golden%20light%2C%20high%20quality%20illustration%2C%20portrait%20composition&width=600&height=800&seq=vol-11&orientation=portrait",
    count: "全彩 6 话",
    tag: "单行本",
    desc: "夏天承载了太多回忆。在海边的约定、烟火的绚烂与彼此的陪伴中，这段感情迎来了最为炽热而纯粹的篇章。",
  },
  {
    id: "v12",
    title: "第12卷",
    subtitle: "心之所向",
    cover: "https://readdy.ai/api/search-image?query=Romance%20shoujo%20manga%20cover%20illustration%2C%20young%20couple%20dancing%20under%20string%20lights%20at%20night%2C%20warm%20golden%20glow%2C%20rose%20petals%20in%20air%2C%20joyful%20romantic%20mood%2C%20delicate%20line%20art%2C%20festive%20yet%20tender%2C%20high%20quality%20artwork%2C%20portrait%20composition&width=600&height=800&seq=vol-12&orientation=portrait",
    count: "全彩 6 话",
    tag: "单行本",
    desc: "历经重重考验，两人终于找到心的方向。在满溢的温暖与欢笑中，他们的故事即将走向一个圆满的答案。",
  },
  {
    id: "v13",
    title: "第13卷",
    subtitle: "甜蜜的终点",
    cover: "https://readdy.ai/api/search-image?query=Romance%20shoujo%20manga%20cover%20illustration%2C%20young%20couple%20in%20an%20embrace%20surrounded%20by%20warm%20light%20and%20rose%20petals%2C%20happy%20fulfilled%20expression%2C%20soft%20cream%20and%20rose%20background%2C%20delicate%20detail%2C%20culminating%20romantic%20finale%20mood%2C%20high%20quality%20illustration%2C%20portrait%20composition&width=600&height=800&seq=vol-13&orientation=portrait",
    count: "全彩 6 话",
    tag: "完结卷",
    desc: "整部单行本迎来甜蜜终章。所有误会、等待与温柔在这一刻汇聚，两人终于走向属于他们的幸福结局，为这段旅程画上圆满句点。",
  },
];

export const heroCover =
  "https://readdy.ai/api/search-image?query=Romance%20shoujo%20manga%20main%20cover%20illustration%2C%20young%20woman%20with%20long%20auburn%20hair%20in%20elegant%20gown%2C%20soft%20rose%20and%20gold%20dreamy%20background%20with%20cherry%20blossoms%2C%20gentle%20romantic%20gaze%2C%20delicate%20line%20art%2C%20luxurious%20and%20tender%20atmosphere%2C%20high%20quality%20digital%20painting%2C%20portrait%20composition&width=900&height=1200&seq=hero-cover&orientation=portrait";

export const heroBg =
  "https://readdy.ai/api/search-image?query=Dreamy%20romantic%20abstract%20background%20of%20soft%20rose%20pink%20and%20warm%20gold%20watercolor%20blooms%2C%20floating%20cherry%20blossom%20petals%2C%20gentle%20bokeh%20light%2C%20elegant%20and%20ethereal%2C%20no%20text%2C%20smooth%20gradients%2C%20soft%20diffused%20lighting%2C%20cinematic%20romantic%20mood%2C%20high%20quality%20digital%20art&width=1600&height=900&seq=hero-bg&orientation=landscape";

export interface Chapter {
  id: string;
  volume: string;
  title: string;
  category: "单行本" | "连载" | "全彩" | "番外";
  isColor: boolean;
  desc: string;
}

export const chapters: Chapter[] = [
  { id: "c1", volume: "第1卷", title: "第1话 · 命运的相遇", category: "单行本", isColor: true, desc: "女主角在一次意外中与男主角相遇，命运的齿轮开始转动。" },
  { id: "c2", volume: "第1卷", title: "第2话 · 无法拒绝的契约", category: "单行本", isColor: true, desc: "为了守护重要的人，女主角签下了一份改变人生的契约。" },
  { id: "c3", volume: "第1卷", title: "第3话 · 陌生的屋檐下", category: "单行本", isColor: true, desc: "搬入新环境的女主角，开始适应与男主角同处一个屋檐下的日常。" },
  { id: "c4", volume: "第1卷", title: "第4话 · 初次的试探", category: "单行本", isColor: true, desc: "一场蓄意的试探，让两人的关系出现微妙的裂缝与靠近。" },
  { id: "c5", volume: "第1卷", title: "第5话 · 深夜的坦白", category: "单行本", isColor: true, desc: "寂静的夜里，两人第一次放下防备，说出彼此的心事。" },
  { id: "c6", volume: "第1卷", title: "第6话 · 契约的代价", category: "单行本", isColor: true, desc: "契约的代价逐渐显现，女主角开始重新审视这段关系的意义。" },
  { id: "c7", volume: "第2卷", title: "第7话 · 隐秘的心动", category: "单行本", isColor: true, desc: "日常相处中，难以言说的悸动悄悄萌芽。" },
  { id: "c8", volume: "第2卷", title: "第8话 · 目光的追随", category: "单行本", isColor: true, desc: "不自觉追随的目光，让两个人都开始在意彼此的存在。" },
  { id: "c9", volume: "第2卷", title: "第9话 · 温柔的破绽", category: "单行本", isColor: true, desc: "冷漠的外壳下，男主角不经意间流露出的温柔被女主角察觉。" },
  { id: "c10", volume: "第3卷", title: "第10话 · 试探与靠近", category: "单行本", isColor: true, desc: "一场误会让两人在矛盾中更加靠近彼此。" },
  { id: "c11", volume: "第3卷", title: "第11话 · 雨中的守护", category: "单行本", isColor: true, desc: "突如其来的大雨中，他用行动回应了她的不安。" },
  { id: "c12", volume: "第4卷", title: "第12话 · 破晓的告白", category: "单行本", isColor: true, desc: "黎明时刻，鼓起勇气的告白让这段感情迎来转折。" },
  { id: "c13", volume: "连载", title: "连载 · 特别篇 盛夏的约定", category: "连载", isColor: false, desc: "海边连载特别篇，讲述两人夏日的约定与回忆。" },
  { id: "c14", volume: "连载", title: "连载 · 圣诞夜的奇迹", category: "连载", isColor: false, desc: "圣诞夜的连载短篇，充满节日温暖与甜蜜。" },
  { id: "c15", volume: "全彩", title: "全彩 · 初遇之章 珍藏版", category: "全彩", isColor: true, desc: "将第一话以全彩形式重新绘制，色彩更为细腻动人。" },
  { id: "c16", volume: "全彩", title: "全彩 · 告白之章 珍藏版", category: "全彩", isColor: true, desc: "告白名场面全彩重制，情感的每一处细节都更加鲜明。" },
  { id: "c17", volume: "全彩", title: "全彩 · 终章 特别版", category: "全彩", isColor: true, desc: "甜蜜终章全彩特别版，为整部作品留下最美的注脚。" },
  { id: "c18", volume: "番外", title: "番外 · 新婚篇", category: "番外", isColor: false, desc: "正篇之后的甜蜜番外，展现两人新婚生活的日常。" },
  { id: "c19", volume: "番外", title: "番外 · 幼年期的小故事", category: "番外", isColor: false, desc: "关于两人童年相遇的小故事，补全他们之间最初的缘分。" },
  { id: "c20", volume: "番外", title: "番外 · 情人节特别篇", category: "番外", isColor: false, desc: "情人节主题番外，充满甜蜜心动的特别企划。" },
];

export const fullColor: Chapter[] = chapters.filter((c) => c.isColor);
export const extras: Chapter[] = chapters.filter((c) => c.category === "番外");
export const serials: Chapter[] = chapters.filter((c) => c.category === "连载");
export const latestChapters: Chapter[] = chapters.slice(0, 6);

export const faqs = [
  {
    q: "甜蜜惩罚漫画单行本一共有多少卷？",
    a: "目前我们收录的《甜蜜惩罚》漫画单行本共13卷，内容完整覆盖整部主线故事。每卷均按顺序整理，读者可从第1卷开始连续阅读，也可以直接进入目录页选择自己想看的卷与话数。",
  },
  {
    q: "网站提供甜蜜惩罚漫画全彩版本吗？",
    a: "是的。除了常规连载话与单行本内容，我们还专门整理收录了甜蜜惩罚漫画全彩版本，包括「初遇之章」「告白之章」「终章」等全彩珍藏篇，为喜欢彩色画面的读者提供更完整的阅读体验。",
  },
  {
    q: "甜蜜惩罚漫画番外在哪里查看？",
    a: "甜蜜惩罚漫画番外被单独归入「番外」分类，收录于阅读目录页。包括新婚篇、幼年期的小故事、情人节特别篇等多个番外内容，与正篇目录分开整理，方便读者快速查找。",
  },
  {
    q: "如何快速找到自己想要阅读的某一卷或某一话？",
    a: "你可以在首页的「热门推荐」中快速开始阅读，也可以进入「阅读目录」页面，按照单行本卷、连载话、全彩版本、番外四个分类进行筛选，轻松定位到任意章节。",
  },
  {
    q: "甜蜜惩罚漫画网的内容是免费阅读的吗？",
    a: "本网站专注于整理与展示《甜蜜惩罚》漫画的完整目录、作品介绍与章节信息，帮助读者更便捷地了解整部作品的卷话结构，并指引后续的阅读方向。",
  },
  {
    q: "网站会持续更新甜蜜惩罚漫画的连载与新内容吗？",
    a: "会的。我们会持续跟进作品的连载更新与各类番外企划，及时整理进目录中，让读者始终能在这里找到最完整的甜蜜惩罚漫画内容清单。",
  },
];

export const feedback = [
  {
    name: "初雪",
    role: "资深乙女漫读者",
    content: "找了好久的单行本全卷终于在这里看全了，目录按卷和话分得清清楚楚，全彩版本也一起收录，真的省心很多。",
  },
  {
    name: "林晚",
    role: "恋爱漫画爱好者",
    content: "番外都整理得很全，新婚篇超甜！页面设计也很舒服，玫瑰色的风格很契合这部作品的浪漫气质。",
  },
  {
    name: "小柚",
    role: "追更读者",
    content: "连载话更新整理得很及时，目录清晰，想回看哪一话都很快能找到，是我日常追这部漫画的常驻站点。",
  },
  {
    name: "阿澄",
    role: "漫画收藏党",
    content: "从第1卷到完结卷整整齐齐，还单独把全彩珍藏版分出来了，细节很用心，找齐整部作品变得特别方便。",
  },
];

export const relatedLink = {
  title: "单行本全卷完整阅读",
  desc: "从第1卷到完结卷，按顺序整理整部《甜蜜惩罚》漫画，一起走完这段充满甜蜜与波折的浪漫旅程。",
};